module.exports = __webpack_public_path__ + "img/courier-dayross.f0d22d75.svg";